// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class BehaviourTutorialBaseService {

  private readonly BEHAVIOUR_TUTORIAL_KEY: string = 'hs:ee:behaviour_tutorial';
  private readonly BEHAVIOUR_TUTORIAL_VERSION: number = 1;
  private readonly BEHAVIOUR_TUTORIAL_OFF: number = 0;

  protected _showTutorial$: BehaviorSubject<boolean>;
  get showTutorial$(): Observable<boolean> {
    return this._showTutorial$;
  }

  protected _tutorialViewed$: BehaviorSubject<boolean>;
  get tutorialViewed$(): Observable<boolean> {
    return this._tutorialViewed$;
  }

  constructor() {
    this._showTutorial$ = new BehaviorSubject<boolean>(false);
    this._tutorialViewed$ = new BehaviorSubject<boolean>(false);

    const version = this._getVersion();
    if (version && Number(version) === this.BEHAVIOUR_TUTORIAL_VERSION) {
      this._tutorialViewed$.next(true);
      return;
    }
    this._tutorialViewed$.next(false);
  }

  begin() {
    this._showTutorial$.next(true);
  }

  complete() {
    this._showTutorial$.next(false);
    this.setVersion();
    this._tutorialViewed$.next(true);
  }

  skip() {
    this._tutorialViewed$.next(true);
    this.setVersion();
  }

  setVersion() {
    localStorage.setItem(
      this.BEHAVIOUR_TUTORIAL_KEY,
      this.BEHAVIOUR_TUTORIAL_VERSION.toString()
    );
  }

  protected _getVersion() {
    const version = localStorage.getItem(this.BEHAVIOUR_TUTORIAL_KEY);
    if (version) {
      return version;
    }
    return this.BEHAVIOUR_TUTORIAL_OFF;
  }

  setVersionOnOff(val: any) {
    if (val) {
      localStorage.setItem(
        this.BEHAVIOUR_TUTORIAL_KEY,
        this.BEHAVIOUR_TUTORIAL_VERSION.toString()
      );
    }
    else {
      localStorage.setItem(
        this.BEHAVIOUR_TUTORIAL_KEY,
        this.BEHAVIOUR_TUTORIAL_OFF.toString()
      );

    }
    this.refreshVersion(val);
  }

  refreshVersion(version: any) {
    if (!version || isNaN(parseInt(version))) {
      version = this._getVersion();
    }
    this._tutorialViewed$.next(parseInt(version) === this.BEHAVIOUR_TUTORIAL_VERSION);
  }
}
